/** Thrown when an authenticated request would otherwise go out with no JWT. */
export class MissingSessionError extends Error {
    constructor() {
        super('No active session');
        this.name = 'MissingSessionError';
    }
}
